/**
 * Formats a seconds value as `HH:MM:SS`.
 * Returns `"—"` for null/undefined/NaN/negative inputs.
 */
export const secondsToHms = (secs: unknown): string => {
  if (secs == null) return "—";
  const n = Number(secs);
  if (!Number.isFinite(n) || n < 0) return "—";
  const h = Math.floor(n / 3600);
  const m = Math.floor((n % 3600) / 60);
  const s = Math.floor(n % 60);
  const pad = (x: number) => String(x).padStart(2, "0");
  return `${pad(h)}:${pad(m)}:${pad(s)}`;
};
